<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import getInitials from '@/helpers/get-initials'
import api from '@/helpers/api'
import simplebar from 'simplebar-vue'

export default {
  name: 'product.view',
  page: {
    title: 'Product',
    meta: [{ name: 'description', settings_content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  props: {
    product_id: { type: String, required: true }
  },
  data: () => ({
    isLoading: false,
    product: {}
  }),
  mounted () {
    this.onInit()
  },
  watch: {
    product_id: 'onInit'
  },

  methods: {
    async onInit () {
      this.isLoading = true
      let item = await api.items.fetch({
        id: this.product_id
      })
      this.product = {
        ...item
      }
      this.isLoading = false
    }
  },
  computed: {
    title () {
      return 'Product'
    },
    breadcrumbs () {
      return [
        {
          text: 'Products',
          to: { name: 'products' }
        },
        {
          text: this.product.code ? `${this.product.code}` : 'loading',
          active: true
        }
      ]
    }
  }
}
</script>
<template>
  <Layout>
    <PageHeader :items="breadcrumbs">
      <template v-slot:title>
        <div class="d-flex flex-column">
          <div>
            <h4 class="mb-0">
              {{ product.code }}
            </h4>
          </div>
          <p class="mb-0">Product Detail</p>
        </div>
      </template>
    </PageHeader>

    <b-row>
      <b-col cols="12">
        <b-card no-body class="email-leftbar p-2">
          <b-nav vertical class="side-nav">
            <b-nav-item :to="{ name: 'products' }" exact class="py-2">
              <i class="bx bx-chevron-left mr-1"></i>Back
            </b-nav-item>

            <b-nav-item :to="{ name: 'products.view.general' }" exact>
              <i class="bx bx-info-circle mr-1"></i>Basic Information
            </b-nav-item>
            <b-nav-item :to="{ name: 'products.view.pricing' }" exact>
              <i class="bx bx-money mr-1"></i>Pricing
            </b-nav-item>
            <b-nav-item
              :to="{ name: 'products.view.sales' }"
              exact
              v-if="product.is_sellable"
            >
              <i class="bx bx-store mr-1"></i>Webshop
            </b-nav-item>
            <b-nav-item :to="{ name: 'products.view.files' }" exact>
              <i class="bx bx-images mr-1"></i>Files & Images
            </b-nav-item>
            <b-nav-item
              :to="{ name: 'products.view.inventory' }"
              exact
              v-if="product.is_stock_item"
            >
              <i class="bx bx-barcode mr-1"></i>Inventory
            </b-nav-item>
            <b-nav-item
              :to="{ name: 'products.view.purchases' }"
              exact
              v-if="product.is_purchaseable"
            >
              <i class="bx bx-buildings mr-1"></i>Purchase
            </b-nav-item>

            <b-nav-item :to="{ name: 'products.view.specs' }" exact>
              <i class="bx bx-slider mr-1"></i>Specifications
            </b-nav-item>

            <b-nav-item
              :to="{ name: 'products.view.materials' }"
              exact
              v-if="false"
            >
              <i class="bx bx-cube mr-1"></i>Materials
            </b-nav-item>

            <b-nav-item
              :to="{ name: 'products.view.other' }"
              exact
              v-if="false"
            >
              <i class="bx bx-cog mr-1"></i>Other Options
            </b-nav-item>
          </b-nav>
        </b-card>

        <div class="email-rightbar">
          <router-view v-on:update="onInit" />
        </div>
      </b-col>
    </b-row>
  </Layout>
</template>
